







































import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { EditRateData } from '@/modules/backend/Dto/EditRateData';
import { Rate } from '@/modules/backend/Entities/Rate';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { resolveModule } from '@/store';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class RateEditDialog extends Mixins(Mixin) {
  @Prop({ required: true })
  private rate!: Rate;

  @Prop()
  private detail!: boolean;

  @Prop({
    required: false,
    type: Number,
    default: undefined
  })
  private readonly accountId?: number;

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  private readonly ratesModule: RatesModule = resolveModule(RatesModule);

  private get editForm(): { name: string; price: number } {
    return {
      name: this.rate.getResource().getTitle().toString(),
      price: this.rate.getPrice()
    };
  }

  private clearForm(): void {
    this.observer.reset();
    this.editForm.name = this.rate.getResource().getTitle().toString();
    this.editForm.price = this.rate.getPrice();
  }

  private async dialogOpenHandler(): Promise<void> {
    this.clearForm();
  }

  private async edit(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      if (this.detail) {
        await this.ratesModule.create({
          resourceId: this.rate.getResource().getId(),
          accountId: this.accountId,
          price: Number(this.editForm.price)
        });
      } else {
        const payload = new EditRateData();
        payload.rateId = this.rate.getId();
        payload.price = Number(this.editForm.price);
        await this.ratesModule.edit(payload);
      }
    } else {
      throw new Error('Validation error');
    }
  }
}
